import axiosInstance from './axiosInstance';

const getLinkDownloadReport = (reportId) =>
  axiosInstance.get(`/internal/admin/reports/${reportId}`);

export default getLinkDownloadReport;
